(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["imagin-delivery"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('imagin-eta')) return;
    function brusselsNow() {
      var parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/Brussels', year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false
      }).formatToParts(new Date());
      var o = {};
      parts.forEach(function (p) { o[p.type] = p.value; });
      return new Date(+o.year, +o.month - 1, +o.day, +o.hour % 24, +o.minute, +o.second);
    }
    /* Belgian public holidays (no shipping, no delivery) + extra closed days from the block setting */
    var HOLIDAYS = ['2026-01-01','2026-04-06','2026-05-01','2026-05-14','2026-05-25','2026-07-21','2026-08-15','2026-11-01','2026-11-11','2026-12-25',
      '2027-01-01','2027-03-29','2027-05-01','2027-05-06','2027-05-17','2027-07-21','2027-08-15','2027-11-01','2027-11-11','2027-12-25',
      '2028-01-01','2028-04-17','2028-05-01','2028-05-25','2028-06-05','2028-07-21','2028-08-15','2028-11-01','2028-11-11','2028-12-25'];
    function ymd(d) { return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0'); }
    function isWeekend(d) { var w = d.getDay(); return w === 0 || w === 6 || HOLIDAYS.indexOf(ymd(d)) > -1; }
    function addWorkingDays(d, n) {
      var r = new Date(d.getTime());
      while (n > 0) { r.setDate(r.getDate() + 1); if (!isWeekend(r)) n--; }
      return r;
    }
    var TEXT = {
      en: function (c) { return { before: 'Order before ' + c + 'h', left: 'left', receive: 'receive it on', order: 'Order now,', locale: 'en-GB' }; },
      nl: function (c) { return { before: 'Bestel voor ' + c + 'u', left: 'over', receive: 'in huis op', order: 'Bestel nu,', locale: 'nl-BE' }; },
      fr: function (c) { return { before: 'Commandez avant ' + c + 'h', left: 'restant', receive: 'reçu le', order: 'Commandez maintenant,', locale: 'fr-BE' }; }
    };
    class ImaginEta extends HTMLElement {
      connectedCallback() { this.render(); this._t = setInterval(this.render.bind(this), 60000); }
      disconnectedCallback() { clearInterval(this._t); }
      render() {
        (this.dataset.closed || '').split(',').map(function (x) { return x.trim(); }).forEach(function (x) { if (/^\d{4}-\d{2}-\d{2}$/.test(x) && HOLIDAYS.indexOf(x) < 0) HOLIDAYS.push(x); });
        var cutoff = parseInt(this.dataset.cutoff, 10) || 13;
        var days = parseInt(this.dataset.days, 10) || 1;
        var maxDays = Math.max(days, parseInt(this.dataset.maxDays, 10) || days);
        var T = (TEXT[this.dataset.lang] || TEXT.en)(cutoff);
        var now = brusselsNow();
        var ship = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        var beforeCutoff = !isWeekend(now) && now.getHours() < cutoff;
        if (!beforeCutoff) ship = addWorkingDays(ship, 1);
        var arrive = addWorkingDays(ship, days);
        var arrive2 = addWorkingDays(ship, maxDays);
        var dateTxt;
        if (maxDays > days) {
          var sameMonth = arrive.getMonth() === arrive2.getMonth();
          var first = arrive.toLocaleDateString(T.locale, sameMonth ? { weekday: 'short', day: 'numeric' } : { weekday: 'short', day: 'numeric', month: 'long' });
          var second = arrive2.toLocaleDateString(T.locale, { weekday: 'short', day: 'numeric', month: 'long' });
          dateTxt = first + ' – ' + second;
        } else {
          dateTxt = arrive.toLocaleDateString(T.locale, { weekday: 'long', day: 'numeric', month: 'long' });
        }
        var html;
        if (beforeCutoff) {
          var end = new Date(now.getFullYear(), now.getMonth(), now.getDate(), cutoff, 0, 0);
          var mins = Math.max(0, Math.round((end - now) / 60000));
          var h = Math.floor(mins / 60), m = mins % 60;
          html = '<strong>' + T.before + '</strong> <span class="idl__count">(' + (h > 0 ? h + 'h ' : '') + m + 'm ' + T.left + ')</span>, ' + T.receive + ' <strong>' + dateTxt + '</strong>';
        } else {
          html = T.order + ' ' + T.receive + ' <strong>' + dateTxt + '</strong>';
        }
        var out = this.querySelector('.idl__eta-text');
        if (out) out.innerHTML = html;
        this.hidden = false;
      }
    }
    customElements.define('imagin-eta', ImaginEta);
  })();
  } catch(e) { console.error(e); }
})();

})();
